import { useMemo } from 'react'

const collectSearchableStrings = (value) => {
  if (value == null) return []

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return [String(value).toLowerCase()]
  }

  if (Array.isArray(value)) {
    return value.flatMap(collectSearchableStrings)
  }

  if (typeof value === 'object') {
    return Object.values(value).flatMap(collectSearchableStrings)
  }

  return []
}

const useGenericTextSearch = (items = [], query = '', getSearchData) => {
  return useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase()
    if (!normalizedQuery) return items

    return items.filter((item) => {
      const source = typeof getSearchData === 'function' ? getSearchData(item) : item
      const searchable = collectSearchableStrings(source)
      return searchable.some((value) => value.includes(normalizedQuery))
    })
  }, [items, query, getSearchData])
}

export default useGenericTextSearch
